var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#838383",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "rgb(131, 131, 131)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9543 9.40876C11.0544 9.60076 7.95357 12.8483 8.00153 16.7998C8.06545 20.7352 11.2622 23.9508 15.1941 23.9988C19.158 24.0628 22.4027 20.9592 22.5785 17.0558C22.5944 16.8638 22.4346 16.7038 22.2428 16.7038H15.6416C15.4498 16.7038 15.29 16.5438 15.29 16.3678V9.7447C15.29 9.5527 15.1462 9.40876 14.9543 9.40876V9.40876ZM16.7125 8.33685V14.9439C16.7125 15.1359 16.8564 15.2799 17.0482 15.2799H23.6653C23.8572 15.2799 24.001 15.1199 24.001 14.9279C23.8252 11.1844 20.8202 8.17687 17.0641 8.00085C16.8724 7.98494 16.7125 8.14491 16.7125 8.33685V8.33685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptDisable);
export default __webpack_public_path__ + "static/media/ppt_disable.e1fac271482daa3c641b722979b5c71e.svg";
export { ForwardRef as ReactComponent };